import { withRouter } from 'react-router-dom';
import { ReportSelectionDropdown as Component } from './ReportSelectionDropdown';

export const ReportSelectionDropdown = withRouter(Component);
